import { useEffect } from 'react';
import { useConfig, useDisconnect } from 'wagmi';
import useAuthStore from '../../../store/rootStore.ts';
import { useDialogStore } from '@/components/dialogs';

export function useGeoBlockCheck() {
  useConfig();
  const isGeoBlocked = useAuthStore((state) => state.config?.isGeoBlocked);
  const userCountry = useAuthStore((state) => state.config?.userCountry);
  const status = useAuthStore((state) => state.status);
  const { disconnect } = useDisconnect();

  useEffect(() => {
    if (!isGeoBlocked || status === 'AUTHORITY_BLOCKED') {
      return;
    }

    useAuthStore.getState().blockByAuthority({ step: 'connect', country: userCountry });
    disconnect();
    useDialogStore.getState().openDialog('geoBlockDialog', { countryCode: userCountry! });
  }, [isGeoBlocked, userCountry, status, disconnect]);
}
